<template>
  <section class="featured-items featured-items--merch">
    <h2 v-if="sectionTitle">
      {{ sectionTitle }}
    </h2>
    <h2 v-else>
      Merchandise
    </h2>
    <div v-if="debugging">
      Total: {{ itemCount.total }}<br>
      Current: {{ itemCount.current }}<br>
      Per Page: {{ itemCount.perPage }}<br>
      Page: {{ itemCount.page }}<br>
      Next: {{ itemCount.next }}<br><br>
      Count: {{ count }}<br><br>
      Products so far: {{ productsSoFar }}
    </div>
    <ul>
      <template
        v-for="(item, index) in filteredItems"
      >
        <li
          v-if="index < itemsSoFar"
          :key="index"
        >
          <Merchandise
            :item="item"
          />
        </li>
      </template>
    </ul>
    <div class="view-more-container">
      <button
        v-if="itemCount.current > itemsSoFar"
        class="button"
        @click="addMoreTrends"
      >
        View {{ itemCount.next }} More of {{ itemsLeft }} {{ itemsLeft > 1 ? 'Items' : 'Item' }}
      </button>
    </div>
  </section>
</template>


<script>
 import Merchandise from "./items/Merchandise.vue"

  import store from "../store"

export default {
  name: "Merch",
   components: {
      Merchandise
    },
    props: {
      page: {
        type: Number,
        required: false,
        default: null
      },
    },
    data() {
      return {
        itemCount: {
          current: 0,
          total: 0,
          perPage: 20,
          page: 1,
          next: 0
        },
        debugging: false
      }
    },
    computed: {
      filteredItems: function() {
        return store.state.items.filter(i => {
          return !i.isExcluded;
        })
      },
      count: function() {
        return this.filteredItems.length;
      },
      itemsLeft: function() {
        return this.itemCount.current - (this.itemCount.perPage * this.itemCount.page)
      },
      itemsSoFar: function() {
        return this.itemCount.perPage * this.itemCount.page
      },
      sectionTitle: function() {
        return window.listTitleOverride
      }
    },
    updated() {
      this.updateCounts()
    },
    mounted() {
      if(this.page){
        this.itemCount.page = this.page
      }
    },
    created() {
      // this.itemCount.total = this.count
      // this.itemCount.current = this.count
      // this.itemCount.next = (this.itemCount.current >= this.itemCount.perPage * (this.itemCount.page + 1)) ? this.itemCount.perPage : this.itemCount.current - (this.itemCount.perPage * this.itemCount.page)
      this.updateCounts()
    },
    methods: {
      updateCounts: function() {
        // console.log('updateCounts')
        this.itemCount.total = this.count
        this.itemCount.current = this.count
        this.itemCount.next = (this.itemCount.current >= this.itemCount.perPage * (this.itemCount.page + 1)) ? this.itemCount.perPage : this.itemCount.current - (this.itemCount.perPage * this.itemCount.page)
        this.$emit('updateCount', this.count)
      },
      filteredTrends: function() {
          //console.log(this.$store.state.items);
          return this.$store.state.items.filter(function(item) {
              return !item.isExcluded;
          });
      },
      addMoreTrends: function() {
        ++this.itemCount.page
        // this.itemCount.current = this.itemCount.current + this.itemCount.perPage
        // eslint-disable-next-line
        if (typeof dataLayer === 'object') {
          // eslint-disable-next-line
          dataLayer.push({
            event: 'genericEvent',
            eventCat: 'product engagement',
            eventAction: 'button click',
            eventLabel: 'View More Products',
          });
        }
        this.$router.push({path: this.$route.path, query: { page: this.itemCount.page }})
      },
      incrementCounter: function(trend) {
        if (!trend.isExcluded) {
          this.liveCounter++
        }
        // console.log('liveCounter', this.liveCounter)
      }
    }
}
 
</script>
